var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Status',{ref:"status",staticClass:"mb-7",on:{"select-meeting":_vm.onSelectMeeting}}),_c('FeedbackActions',{ref:"feedback",on:{"saved":_vm.onSavedResults}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }